import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import {
  GetIndicatorsGQL,
  GetIndicatorsQuery,
} from "src/generated/graphql/sustainability/indicator.graphql";
import { IRelevantInformation } from "./interfaces/relevant-information.interface";
import { IIndicator } from "./interfaces/indicator.interface";
import { TranslateService } from "@ngx-translate/core";
import { QueryRef } from "apollo-angular";
import {
  GetScoringCriteriaGQL,
  GetScoringCriteriaQuery,
} from "src/generated/graphql/scoringCriteria/get-scoringCriteria.graphql";
import { ScoringCriteria } from "src/generated/graphql/scoringCriteria/scoringCriteria.graphql";
import {
  GetAwardCriteriaGQL,
  GetAwardCriteriaQuery,
} from "src/generated/graphql/AwardCriteria/get-awardCriteria.graphql";
import { AwardCriteria } from "src/generated/graphql/AwardCriteria/awardCriteria.graphql";
import { FormArray, FormBuilder, FormGroup } from "@angular/forms";
import { IndicatorCalculationService } from "src/app/service/IndicatorCalculation.service";
import { take } from "rxjs/operators";
import { AuthorService } from "src/app/service-state/authors-state.service";
import { formatDate } from "@angular/common";
import { isNull } from "util";
import { emit } from "cluster";

type Formula = {
  [unit: string]: (qtd: number) => number;
};

type Formulas = {
  [material: string]: Formula;
};

@Component({
  selector: "app-relevant-information",
  templateUrl: "./relevant-information.component.html",
  styleUrls: ["./relevant-information.component.scss"],
})
export class RelevantInformationComponent implements OnInit, OnChanges {
  formInformationRelevation: FormGroup;

  backgroundColorFinancial: string = "white";
  backgroundColorSustainability: string = "white";
  backgroundColorProductivity: string = "white";

  labelAmbiental: string = "----";
  labelProdutivy: string = "----";
  labelFinancial: string = "----";

  private formulas: Formulas = {
    "drinking water": {
      m3: (qtd) => (qtd * 0.2) / 1000,
      Litros: (qtd) => (qtd * 0.2) / 1000000,
    },
    "pw water": {
      m3: (qtd) => (qtd * 0.5) / 1000,
      Litros: (qtd) => (qtd * 0.5) / 1000000,
    },
    "wfi water": {
      m3: (qtd) => (qtd * 0.8) / 1000,
      Litros: (qtd) => (qtd * 0.8) / 1000000,
    },
    energy: {
      KWh: (qtd) => qtd * 0.5,
    },
    paper: {
      kg: (qtd) => (qtd * 1.5) / 1000,
      Folhas: (qtd) => (qtd * 0.00000467775 * 1.5) / 1000000,
    },
    metal: {
      kg: (qtd) => qtd * 5.5,
    },
    plastic: {
      kg: (qtd) => qtd * 3.5,
    },
    glass: {
      kg: (qtd) => qtd * 1.2,
    },
    rubber: {
      kg: (qtd) => qtd * 10,
    },
    "danger Residue": {
      kg: (qtd) => qtd * 1,
    },
    glp: {
      m3: (qtd) => qtd * 2,
      Litros: (qtd) => (qtd * 2) / 1000,
    },
    gn: {
      m3: (qtd) => qtd * 0.5,
      Litros: (qtd) => (qtd * 0.5) / 1000,
    },
    diesel: {
      Litros: (qtd) => (qtd * 2.7) / 1000,
    },
    gas: {
      Litros: (qtd) => (qtd * 2.3) / 1000,
    },
    alcohol: {
      Litros: (qtd) => (qtd * 1.8) / 1000,
    },
  };

  color: string = "";
  language: string;

  @Input()
  numberOfAuthors: number = 1;

  @Input()
  ideaConclusionUpdated: IRelevantInformation;

  @Input()
  isEdit: boolean;

  getAllIndicatorQuery: QueryRef<GetIndicatorsQuery>;
  getAllScoringCriteriaQuery: QueryRef<GetScoringCriteriaQuery>;
  getAllAwardCriteriaQuery: QueryRef<GetAwardCriteriaQuery>;

  awardCriteria: AwardCriteria[];

  @Output()
  relevantInformationChange = new EventEmitter<IRelevantInformation>();

  relevantInformation: IRelevantInformation = {
    id: null,
    productivityIncrease: 0,
    financialReturn: 0,
    indicators: [
      {
        name: "",
        quantity: 0,
        unity: "",
        pontuation: 0,
      },
    ],
    environmentImpact: 0,
    premiationDate: new Date(),
    totalPontuation: 0,
    financialCriterion: "---",
    sustainabilityCriterion: "---",
    productivityCriterion: "---",
    prize: 0,
    update: false,
  };

  financialCriterion: ScoringCriteria[];
  sustainabilityCriterion: ScoringCriteria[];
  productivityCriterion: ScoringCriteria[];

  indicators: string[];

  constructor(
    private getScoringCriteriaGQL: GetScoringCriteriaGQL,
    private getAwardCriteriaGQL: GetAwardCriteriaGQL,
    public translate: TranslateService,
    private fb: FormBuilder,
    private indicatorCalculationService: IndicatorCalculationService,
    private authorService: AuthorService,
  ) {
    const currentDate = formatDate(new Date(), "dd/MM/yyyy", "pt-BR");
    this.formInformationRelevation = this.fb.group({
      financial: this.fb.group({
        value: 0,
        label: "----",
        point: 0,
        error: "",
      }),
      productivity: this.fb.group({
        value: 0,
        label: "----",
        point: 0,
        error: "",
      }),
      sustainability: this.fb.group({
        value: [{ value: 0, disabled: true }],
        label: "----",
        point: 0,
        error: "",
      }),
      indicators: this.fb.array([]),
      dataPremiation: this.fb.control(currentDate),
      pontuationTotal: this.fb.control(""),
      quantityAuthors: this.fb.control(0),
      premiationColaboration: this.fb.control(0),
      premioIdea: this.fb.control(""),
    });

    this.formInformationRelevation
      .get("sustainability.value")
      .valueChanges.subscribe((value) => {
        this.updateLabelsByField(value, "sustainability");
      });

    this.formInformationRelevation
      .get("financial.value")
      .valueChanges.subscribe((value) => {
        this.updateLabelsByField(value, "financial");
      });

    this.formInformationRelevation
      .get("productivity.value")
      .valueChanges.subscribe((value) => {
        this.updateLabelsByField(value, "productivity");
      });

    this.formInformationRelevation
      .get("quantityAuthors")
      .valueChanges.subscribe((value) => {

        const valuePremioIdea =
          this.formInformationRelevation.get("premioIdea").value;

        const labelFinancial =
          this.formInformationRelevation.get("financial.label").value;

        if (valuePremioIdea >= 120000 || labelFinancial == "above") {
          const valueColaboration = valuePremioIdea / value;
          this.formInformationRelevation
            .get("premiationColaboration")
            .setValue(valueColaboration);
        }

      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.ideaConclusionUpdated.update) {

      this.formInformationRelevation
        .get("premioIdea")
        .setValue(this.ideaConclusionUpdated.prize, { emitEvent: false });

      this.formInformationRelevation
        .get("productivity.value")
        .setValue(this.ideaConclusionUpdated.productivityIncrease);

      this.formInformationRelevation
        .get("pontuationTotal")
        .setValue(this.ideaConclusionUpdated.totalPontuation, {
          emitEvent: false,
        });

      this.formInformationRelevation
        .get("financial.value")
        .setValue(this.ideaConclusionUpdated.financialReturn);

      this.formInformationRelevation
        .get("sustainability.value")
        .setValue(this.ideaConclusionUpdated.environmentImpact);

      (this.formInformationRelevation.get("indicators") as FormArray).clear();
      this.ideaConclusionUpdated.indicators.forEach((indicator) => {
        this.addFormGroupIndicators(indicator);
      });
    }
  }

  updateLabelsByField(value: number, field: string): void {
    let result = this.setLabelValues(value, field);

    if (!result) {
      this.formInformationRelevation.get(field).patchValue({
        error: "digite um valor correto",
        label: "Digite um valor válido",
        point: 0,
      });

      if (field == "sustainability") {
        this.backgroundColorSustainability = "red";
      } else if (field == "financial") {
        this.backgroundColorFinancial = "red";
      } else {
        this.backgroundColorProductivity = "red";
      }
    } else {
      let { lavelName, points } = result;
      this.formInformationRelevation.get(field).patchValue({
        label: lavelName,
        point: points,
      });

      if (field == "sustainability") {
        this.backgroundColorSustainability = this.handleColor(
          this.translate.instant(lavelName),
        );
      } else if (field == "financial") {
        this.backgroundColorFinancial = this.handleColor(
          this.translate.instant(lavelName),
        );
      } else {
        this.backgroundColorProductivity = this.handleColor(
          this.translate.instant(lavelName),
        );
      }
    }
  }

  setPremiation(): number {
    const financial =
      this.formInformationRelevation.get("financial").value.point;
    const produtivity =
      this.formInformationRelevation.get("productivity").value.point;
    const sustentability =
      this.formInformationRelevation.get("sustainability").value.point;
    return financial + produtivity + sustentability;
  }

  ngOnInit(): void {
    this.loadIndicators();
    this.getAllScoringCriteria();
    this.getAllAwardCriteria();

    this.authorService.authorCount$.subscribe((count) => {
      this.formInformationRelevation.get("quantityAuthors").setValue(count);
    });
  }

  colorMap = {
    pt: {
      "Não atende": "#FAC300",
      "Atende parcialmente": "#84C2FB",
      "Atende plenamente": "#FB84F9",
      Supera: "#62FFA1",
      Acima: "#62FFA1",
    },
    es: {
      "No atiende": "#FAC300",
      "Cumple parcialmente": "#84C2FB",
      "Cumple plenamente": "#FB84F9",
      Supera: "#62FFA1",
      Acima: "#62FFA1",
    },
  };

  get indicatorsArray(): FormArray {
    return this.formInformationRelevation.get("indicators") as FormArray;
  }

  handleColor(value: string) {
    this.language = localStorage.getItem("culture");
    const formatLanguage = this.language?.split("-")[0];

    return this.colorMap[formatLanguage][value];
  }

  setLabelValues(
    value: number,
    input: string,
  ): { lavelName: string; points: number } | undefined {
    if (input === "financial") {
      const match = this.financialCriterion.find(
        (data) =>
          value >= data.minValue &&
          (data.maxValue === null || value <= data.maxValue),
      );

      if (match) {
        return { lavelName: match.scoreLevel.levelName, points: match.points };
      }
      return undefined;
    }
    if (input === "productivity") {
      const match = this.productivityCriterion.find(
        (data) => value >= data.minValue && value <= data.maxValue,
      );

      if (match) {
        return { lavelName: match.scoreLevel.levelName, points: match.points };
      }
      return undefined;
    }
    if (input === "sustainability") {
      const match = this.sustainabilityCriterion.find(
        (data) =>
          value >= data.minValue &&
          (data.maxValue === null || value <= data.maxValue),
      );

      if (match) {
        return { lavelName: match.scoreLevel.levelName, points: match.points };
      }
      return undefined;
    }
  }

  getAllScoringCriteria() {
    this.getAllScoringCriteriaQuery = this.getScoringCriteriaGQL.watch();
    this.getAllScoringCriteriaQuery.valueChanges.subscribe({
      next: (result) => {
        const intervals = result.data.getScoringCriterias;

        this.financialCriterion = this.filterCriterion(intervals, "financial");

        this.sustainabilityCriterion = this.filterCriterion(
          intervals,
          "sustainability",
        );

        this.productivityCriterion = this.filterCriterion(
          intervals,
          "productivity",
        );

        this.updateLabelsByField(0, "sustainability");
        this.updateLabelsByField(0, "financial");
        this.updateLabelsByField(0, "productivity");
      },
      error: (error) => {
        console.error("Error loading criterion intervals", error);
      },
    });
  }

  getAllAwardCriteria() {
    this.getAllAwardCriteriaQuery = this.getAwardCriteriaGQL.watch();
    this.getAllAwardCriteriaQuery.valueChanges.subscribe({
      next: (value) => {
        this.awardCriteria = value.data.getAwardCriterias.sort(
          (a: AwardCriteria, b: AwardCriteria) => {
            if (a.numberOfPoints === null) return 1;
            if (b.numberOfPoints === null) return -1;
            return a.numberOfPoints - b.numberOfPoints;
          },
        );
        this.setChangesForm();
      },
      error: (error) => {
        console.error("Error loadding award criteria", error);
      },
    });
  }

  setChangesForm() {
    this.formInformationRelevation.statusChanges.subscribe((status) => {
      if (status == "VALID") {
        const valorTotal = this.setPremiation();
        this.formInformationRelevation
          .get("pontuationTotal")
          .setValue(valorTotal, { emitEvent: false });
        this.calculateTeamAndIndividualPrize(valorTotal);
        this.setEventIRelevation();
      }
    });
  }

  filterCriterion(
    intervals: ScoringCriteria[],
    key: string,
  ): ScoringCriteria[] {
    return intervals.filter(
      (interval) => interval.remuneration.name.toLowerCase() === key,
    );
  }

  loadIndicators() {
    this.indicatorCalculationService
      .getIndicatorCalculations()
      .pipe(take(1))
      .subscribe({
        next: (resp) => {
          this.indicators = resp.getIndicatorCalculations.map(
            (indicator) => indicator.indicator,
          );
          this.addFormGroupIndicators();
        },
      });
  }

  addFormIndicator(): void {
    this.addFormGroupIndicators();
  }

  executeFormula(type: string, key: string, qtd: number): number | undefined {
    if (this.formulas[type] && this.formulas[type][key]) {
      return this.formulas[type][key](qtd);
    } else {
      console.error(`Formula or key not found: type=${type}, key=${key}`);
      return undefined;
    }
  }

  addFormGroupIndicators(
    indicator: IIndicator = {
      id: "",
      name: "",
      quantity: 0,
      unity: "",
      pontuation: 0,
    },
  ): void {
    const formGroupIndicators = this.fb.group({
      indicators: [this.indicators],
      selectedIndicator: indicator.name,
      quantity: indicator.quantity,
      unidades: [["Litros", "m3", "kg", "KWh", "Folhas"]],
      selectedUnidade: indicator.unity,
      pontuation: indicator.pontuation,
    });

    if (indicator.id) {
      formGroupIndicators.addControl("id", this.fb.control(indicator.id));
    }

    formGroupIndicators
      .get("selectedIndicator")
      ?.valueChanges.subscribe((newValue) => {
        const unidadesControl = formGroupIndicators.get("unidades");
        const selectedUnidadesControl =
          formGroupIndicators.get("selectedUnidade");
        const listUnidades = Object.keys(this.formulas[newValue]);
        unidadesControl?.setValue(listUnidades);
        selectedUnidadesControl?.setValue(listUnidades[0]);
      });

    formGroupIndicators.get("selectedUnidade")?.valueChanges.subscribe(() => {
      this.updatePontuationValueIndicators(formGroupIndicators);
    });

    formGroupIndicators.get("quantity")?.valueChanges.subscribe(() => {
      this.updatePontuationValueIndicators(formGroupIndicators);
    });

    formGroupIndicators.statusChanges.subscribe((status) => {
      if (status == "VALID") {
        this.updateSustainabilityValue();
      }
    });
    (this.formInformationRelevation.get("indicators") as FormArray).push(
      formGroupIndicators,
    );
  }

  updatePontuationValueIndicators(formGroupIndicators: FormGroup) {
    const pontuationControl = formGroupIndicators.get("pontuation");
    const quantityValue = formGroupIndicators.get("quantity").value;
    const unidadesValue = formGroupIndicators.get("selectedUnidade").value;
    const indicatorValue = formGroupIndicators.get("selectedIndicator").value;
    const result = this.executeFormula(
      indicatorValue,
      unidadesValue,
      quantityValue,
    );
    if (!result) {
      pontuationControl?.reset();
    }
    pontuationControl?.setValue(result);
  }

  updateSustainabilityValue() {
    const indicatorsArray = this.formInformationRelevation.get(
      "indicators",
    ) as FormArray;

    const total = indicatorsArray.controls.reduce((sum, group) => {
      const pontuation = group.get("pontuation")?.value;
      return sum + (pontuation && !isNaN(pontuation) ? pontuation : 0);
    }, 0);

    const sustainabilityControl = this.formInformationRelevation.get(
      "sustainability.value",
    );
    sustainabilityControl?.setValue(total, { emitEvent: true });
  }

  removeIndicator(index: number) {
    this.indicatorsArray.removeAt(index);
  }

  calculateTeamAndIndividualPrize(pontuation: number) {
    const numberOfAuthors =
      this.formInformationRelevation.get("quantityAuthors").value;

    const hasTeam = numberOfAuthors > 1;
    let selectedAboveAward = null;

    const len_awardCriteria = this.awardCriteria.length - 1;
    let totalValor = 0;

    // SE PONTUAÇÃO MAIOR QUE ZERO
    if (pontuation > 0) {


      this.awardCriteria.reduce((prev, next, index) => {
        if (
          index === 1 &&
          pontuation <= prev.numberOfPoints &&
          pontuation <= next.numberOfPoints
        ) {
          selectedAboveAward = prev;
          return next;
        } else if (
          pontuation > prev.numberOfPoints && (pontuation <= next.numberOfPoints || next.numberOfPoints == null)
        ) {
          selectedAboveAward = next;
          return next;
        } else {
          if (index == len_awardCriteria && !selectedAboveAward) {
            selectedAboveAward = next;
          }
          return next;
        }
      });

      // SE É MAIS DE 1 COLABORADOR
      if (!hasTeam) {

        this.formInformationRelevation
          .get("premiationColaboration")
          .setValue(selectedAboveAward.individual / numberOfAuthors, {
            emitEvent: false,
          });

        totalValor = selectedAboveAward.individual;
      } else {

        this.formInformationRelevation
          .get("premiationColaboration")
          .setValue(selectedAboveAward.team / numberOfAuthors, {
            emitEvent: false,
          });

        totalValor = selectedAboveAward.team;
      }
    }

    const labelFinancial =
      this.formInformationRelevation.get("financial.label").value;

    // TOTAL_VALOR VAI AT´W 120.000
    if (labelFinancial == "above") {
      let volorFinancial =
        this.formInformationRelevation.get("financial.value").value;

      totalValor = volorFinancial * 0.05;

      this.formInformationRelevation
        .get("premiationColaboration")
        .setValue(totalValor / numberOfAuthors, { emitEvent: false });

    }

    // TOTAL_VALOR VAI ATÉ 120.000
    if (totalValor > 120000) {
      totalValor = 120000;
      const valueColaboration = totalValor / numberOfAuthors;

      this.formInformationRelevation
        .get("premiationColaboration")
        .setValue(valueColaboration, { emitEvent: false });

    }

    this.formInformationRelevation
      .get("premioIdea")
      .setValue(totalValor, { emitEvent: false });
  }

  setEventIRelevation() {
    this.onPremiationDateChanges();
    this.relevantInformation.totalPontuation =
      this.formInformationRelevation.get("pontuationTotal").value;

    const valorReturn =
      this.formInformationRelevation.get("financial.value").value;
    if (valorReturn) {
      this.relevantInformation.financialReturn = parseFloat(valorReturn);
    }
    this.relevantInformation.financialCriterion =
      this.formInformationRelevation.get("financial.label").value;
    this.relevantInformation.sustainabilityCriterion =
      this.formInformationRelevation.get("sustainability.label").value;

    this.relevantInformation.productivityCriterion =
      this.formInformationRelevation.get("productivity.label").value;

    this.relevantInformation.prize =
      this.formInformationRelevation.get("premioIdea").value;

    const valorHH: string =
      this.formInformationRelevation.get("productivity.value").value;

    this.relevantInformation.productivityIncrease = parseFloat(valorHH);

    this.relevantInformation.indicators = (
      this.formInformationRelevation.get("indicators") as FormArray
    ).controls.map((indicador) => {
      const indicator = {
        name: indicador.get("selectedIndicator").value,
        quantity: parseFloat(indicador.get("quantity").value),
        unity: indicador.get("selectedUnidade").value,
        pontuation: indicador.get("pontuation").value,
      };
      if (indicador.get("id")?.value) {
        indicator["id"] = indicador.get("id")?.value;
      }
      return indicator;
    });
    this.relevantInformation.environmentImpact = parseFloat(
      this.formInformationRelevation.get("sustainability.value").value,
    );

    this.relevantInformationChange.emit(this.relevantInformation);
  }

  onPremiationDateChanges() {
    const date = this.formInformationRelevation.get("dataPremiation").value;
    const [day, month, year] = date.split("/").map(Number);
    let data = new Date(year, month - 1, day);
    this.relevantInformation.premiationDate = data;
    this.relevantInformationChange.emit(this.relevantInformation);
  }
}
